import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import "../public/main.css";
import AppLink from "@/components/AppLink.vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { configure } from "vue-gtag";
import '@/assets/fonts.css';

// Import Bootstrap
import './scss/custom-bootstrap.scss';
import "../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

// This function fetches the config scripts globally
function loadConfig() {
  return new Promise((resolve, reject) => {
    const env = process.env.VUE_APP_ENV || 'ops';
    const configMap = {
      local: '/config/config.local.js',
      docker: '/config/config.docker.js',
      ops: '/config/config.js'
    };
    const configFile = configMap[env] || configMap.ops;
    console.log(`Using config file: ${configFile}`);

    try{
    const script = document.createElement('script');
    script.src = configFile;
    script.onload = resolve;
    script.onerror = reject;

    document.head.appendChild(script);
    } catch (error) {
      console.error("Fatal: Could not load application configuration!", error);
    }
  });
}

async function initApp() {
  // Wait for the configuration to be loaded before starting the app
  await loadConfig();


  const app = createApp(App);

  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);

  configure({
    tagId: "G-JWQL7TQB7H"
  })

  app.component("AppLink", AppLink).use(pinia).use(router).use(VCalendar,{}).mount("#app");
}

// Start the app
initApp();